import { render, staticRenderFns } from "./CriterioSelectOffers.vue?vue&type=template&id=08cf7a77"
import script from "./CriterioSelectOffers.vue?vue&type=script&lang=js"
export * from "./CriterioSelectOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports